<template>
  <div class="app-date-picker">
    <v-dialog
      v-model="show"
      :disabled="disabled"
      width="290px"
      full-width
    >
      <v-text-field
        slot="activator"
        :value="dateDisplayText"
        :label="label"
        :placeholder="placeholder"
        :clearable="clearable"
        :error-messages="$formErrors(v)"
        :disabled="disabled"
        @input="clear"
        readonly
      >
        <span
          slot="label"
          :class="{ 'required-field': isRequired && !hideRequired }"
        >
          {{ label }}
        </span>
      </v-text-field>
      <v-date-picker
        :value="convertDateToISO(value)"
        :min="convertDateToISO(min)"
        :max="convertDateToISO(max)"
        :readonly="readonly"
        @change="change"
        color="secondary"
        locale="pt-br"
        scrollable
      />
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AppDatePicker',
  props: {
    value: { 
      type: [ String, Date ],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    min: { 
      type: [ String, Date ],
      default: null
    },
    max: {
      type: [ String, Date ],
      default: null
    },
    clearable: {
      type: Boolean, default: () => true 
    },
    v: {
      type: Object, default: () => {} 
    },
    readonly: {
      type: Boolean, default: () => false 
    },
    disabled: {
      type: Boolean, default: () => false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    hideRequired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    dateDisplayText() {
      return this.value ? this.$date(this.value) : undefined
    },
    isRequired() {
      return this.v?.$params?.required
    }
  },
  methods: {
    convertDateToISO(date) {
      try {
        if (date) return moment(date).format('YYYY-MM-DD')
        return date
      } catch (err) {
        console.log(err)
        return
      }
    },
    clear(value) {
      if (!value) {
        this.$emit('input', null)
        this.$emit('change', null)
      }
    },
    change(value) {
      if (this.closeOnSelect) {
        this.show = false
      }
      this.$emit('input', `${value}T12:00:00.000Z`)
      this.$emit('change', `${value}T12:00:00.000Z`)
    }
  }
}
</script>
